export const LinkTipusok = Object.freeze({
  /** 294 */
  Belso: 294,
  /** 295 */
  Kulso: 295,
});
